export default __webpack_public_path__ + "static/logo_eco_passport-7d27ae5698f928121d4f9aae4d0e7b49.png";